/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import Container from "react-bootstrap/Container";
import { Link } from "react-router-dom";

/* Helpers, constants, custom methods, internal libraries */
import { AIRLINEPROGRAMS_ROUTE } from "../../constants/routes";

/* Components */
import { ReactComponent as AlaskaAirlinesIconSvg } from "../../resources/images/alaska-airlines-icon.svg";
import Breadcrumbs from "../breadcrumbs";

/* Styles */
import styles from "./styles.js"

const ASProgramHeader = ({airlineProgramsData}) => {

    const theme = useTheme();
    const classes = styles({ theme });
    const airline = airlineProgramsData?.suppliers?.find((airline) => airline?.providerCode === "AS" );

    return (
        <>
            <Breadcrumbs
                items={[
                    <Link to={AIRLINEPROGRAMS_ROUTE}>
                        <FormattedMessage id="breadcrumbs.join"/>
                    </Link>,
                    <FormattedMessage id="airlineProgram.alaskaAirlines.title" />
                ]}
            />
            <div className={classes.asProgramPageHeader}>
                <Container className={classes.container}>
                    <AlaskaAirlinesIconSvg />
                    <div>
                        <div className={classes.header}>
                            <h1 className={classes.title}>
                                <FormattedMessage id="airlineProgram.alaskaAirlines.title" />
                            </h1>
                            { 
                                airline && airline?.userStatus === "ACTIVE" && (
                                <div className={classes.connected}>
                                    <FormattedMessage id="join.airlinePrograms.connectedText" />
                                </div>
                                )
                            }
                        </div>
                        <FormattedMessage id="airlineProgram.alaskaAirlines.description" />
                    </div>
                </Container>
            </div>
        </>
    )
}

export default ASProgramHeader;
